import { ArrowUpRight, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function BrandCard({ brand, learnMorePath = "/our-brands" }) {
  return (
    <article
      className="group flex flex-col bg-white border border-slate-200 rounded-md overflow-hidden hover:shadow-lg hover:-translate-y-1 transition-all duration-300"
      data-testid={`brand-card-${brand.slug}`}
    >
      <div className="aspect-[16/10] overflow-hidden bg-slate-50 border-b border-slate-100 flex items-center justify-center p-8">
        <img
          src={brand.logo}
          alt={`${brand.name} logo`}
          loading="lazy"
          className="max-h-full max-w-[70%] object-contain group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="p-6 md:p-7 flex-1 flex flex-col">
        <p className="label-eyebrow text-safety">{brand.eyebrow}</p>
        <h3 className="mt-3 font-display font-bold text-2xl text-navy">{brand.name}</h3>
        <p className="mt-3 text-sm leading-relaxed text-slate-600">{brand.summary}</p>
        <ul className="mt-5 grid grid-cols-1 gap-1.5 text-sm text-slate-600">
          {brand.points.map((p) => (
            <li key={p} className="flex items-start gap-2">
              <span className="mt-2 h-1.5 w-1.5 bg-safety rounded-sm flex-shrink-0" />
              <span>{p}</span>
            </li>
          ))}
        </ul>
        <div className="mt-6 pt-6 border-t border-slate-100 flex flex-wrap items-center gap-3">
          <a
            href={brand.url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`brand-card-visit-${brand.slug}`}
            className="inline-flex items-center gap-2 bg-safety hover:bg-[#e66e00] text-white font-semibold text-sm px-4 py-2.5 rounded-md transition-colors"
          >
            Visit website <ArrowUpRight className="h-4 w-4" />
          </a>
          <Link
            to={learnMorePath}
            data-testid={`brand-card-learn-${brand.slug}`}
            className="inline-flex items-center gap-2 border border-navy text-navy hover:bg-slate-50 font-semibold text-sm px-4 py-2.5 rounded-md transition-colors"
          >
            Learn more <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </article>
  );
}
